module.exports = __webpack_public_path__ + "media/assets/images/blog/POST-ALTER-1-25-8ae5c9fa672cee4b5b54d4c0288adbeb.png";